const Modal = {
  baseStyle: {
    overlay: {
      bg: 'bg.overlay'
    },
    dialogContainer: {
      
    },
    dialog: {
      borderRadius: '16px'
    },
    header: {
      p: '20px 20px 0'
    },
    closeButton: {},
    body: {
      p: '0 20px 20px'
    },
    footer: {
      p: '20px'
    }
  },
  variants: {
    form: {
      dialogContainer: {
      },
      dialog: {
        //maxW: '632px',
        maxW: '1000px',
        p: '20px',
        my: '25px',
        maxH: 'calc(100% - 50px)',
        overflowY: 'auto',
      },
      header: {
        color: '#0A0D14',
        fontSize: '24px',
        fontWeight: 600,
        lineHeight: '100%',
        letterSpacing: '-0.36px',
        span: {
          display: 'block',
          color: '#525866',
          fontSize: '16px',
          fontWeight: 400,
          lineHeight: '125%',
          letterSpacing: '-0.096px'
        }
      },
      body: {
        mt: '20px',
        overflowY: 'auto'
      },
      closeButton: {
        top: '16px',
        right: '16px',
      },
      footer: {
        p: '20px 0 0'
      }
    }
  },
  sizes: {
    
  },
  defaultProps: {
    
  }
};

export default Modal;
